import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { ScrollToOnInitDirective } from './scroll-to-on-init.directive';
import { ScrollToDirective } from './scroll-to.directive';
export var ScrollToComponentNgModule = module(baseModuleId + ".scroll-to", [])
    .directive('scrollTo', ScrollToDirective)
    .directive('scrollToOnInit', ScrollToOnInitDirective);
